/**
 * Tailwind CSS default breakpoints
 * These match Tailwind's default theme breakpoints
 * @see https://tailwindcss.com/docs/breakpoints
 */
export const BREAKPOINTS = {
  sm: '(max-width: 639px)',
  md: '(max-width: 767px)',
  lg: '(max-width: 1023px)',
  xl: '(max-width: 1279px)',
  '2xl': '(max-width: 1535px)',
} as const

export type Breakpoint = keyof typeof BREAKPOINTS
